export default __webpack_public_path__ + "static/media/confetti_left.bb85bae3.png";